"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockFloater = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ui_1 = require("@jsonjoy.com/ui");
const nano_theme_1 = require("nano-theme");
const ExpandableToolbar_1 = require("@jsonjoy.com/ui/lib/4-card/Toolbar/ToolbarMenu/ExpandableToolbar");
const PositionAtPoint_1 = require("@jsonjoy.com/ui/lib/utils/popup/PositionAtPoint");
const useClickAway_1 = require("@jsonjoy.com/ui/lib/hooks/useClickAway");
const context_1 = require("../context");
const handleClass = (0, nano_theme_1.rule)({
    trs: 'opacity .25s ease',
});
exports.BlockFloater = ui_1.isMobile
    ? () => null
    : () => {
        const mutxt = (0, context_1.useMuTxt)();
        const state = mutxt.block;
        const cursor = mutxt.cursor.use();
        const readOnly = mutxt.readOnly.use();
        const dismissed = state.dismissed.use();
        const omniOpen = mutxt.omni.open.use();
        const availableWidth = mutxt.sizer.width.use();
        const desiredWidth = mutxt.sizer.content.use();
        mutxt.version.use();
        mutxt.scrollVersion.use();
        mutxt.editableBox.use();
        mutxt.wnd.use();
        const width = Math.min(availableWidth, desiredWidth);
        const transparent = width > 900;
        const handleRef = React.useRef(null);
        const clickAwayRef = (0, useClickAway_1.useClickAway)(React.useCallback(() => {
            state.dismissed.next(true);
        }, [state]));
        const composedRef = React.useCallback((el) => {
            handleRef.current = el;
            clickAwayRef(el);
        }, [clickAwayRef]);
        const syncFloaterPosition = React.useCallback(() => {
            const handle = handleRef.current;
            if (!handle)
                return;
            const el = handle.parentElement;
            if (!el)
                return;
            const s = el.style;
            const next = state.point();
            if (!next || !state.isInViewport(next)) {
                if (s.display !== 'none')
                    s.display = 'none';
                return;
            }
            const { x, y, dx, dy } = next;
            const desiredLeft = dx >= 0 ? x + 'px' : '';
            const desiredRight = dx >= 0 ? '' : window.innerWidth - x + 'px';
            const desiredTop = dy >= 0 ? y + 'px' : '';
            const desiredBottom = dy >= 0 ? '' : window.innerHeight - y + 'px';
            if (s.display === 'none')
                s.display = '';
            if (s.left !== desiredLeft)
                s.left = desiredLeft;
            if (s.right !== desiredRight)
                s.right = desiredRight;
            if (s.top !== desiredTop)
                s.top = desiredTop;
            if (s.bottom !== desiredBottom)
                s.bottom = desiredBottom;
        }, [state]);
        React.useEffect(() => {
            const id = window.setInterval(syncFloaterPosition, 1000);
            return () => window.clearInterval(id);
        }, [syncFloaterPosition]);
        React.useEffect(() => {
            let resumeTimer = null;
            const onScroll = () => {
                const handle = handleRef.current;
                if (handle) {
                    if (handle.style.opacity !== '0')
                        handle.style.opacity = '0';
                    const el = handle.parentElement;
                    if (el && el.style.visibility !== 'hidden')
                        el.style.visibility = 'hidden';
                }
                if (resumeTimer !== null)
                    clearTimeout(resumeTimer);
                resumeTimer = window.setTimeout(() => {
                    resumeTimer = null;
                    syncFloaterPosition();
                    const handle = handleRef.current;
                    if (!handle)
                        return;
                    const el = handle.parentElement;
                    if (el)
                        el.style.visibility = '';
                    window.requestAnimationFrame(() => {
                        const handle = handleRef.current;
                        if (handle)
                            handle.style.opacity = '';
                    });
                }, 350);
            };
            const unsubscribe = mutxt.scroll.scrollTop$.subscribe(onScroll);
            return () => {
                unsubscribe();
                if (resumeTimer !== null)
                    clearTimeout(resumeTimer);
            };
        }, [mutxt, syncFloaterPosition]);
        if (readOnly || !cursor || mutxt.api.hasSelection())
            return;
        if (dismissed || omniOpen || !state.currentBlockFormat())
            return;
        const point = state.point();
        if (!point || !state.isInViewport(point))
            return;
        const menu = state.menu.build();
        if (!menu)
            return;
        return (React.createElement(PositionAtPoint_1.PositionAtPoint, { point: point, animate: true },
            React.createElement("div", { ref: composedRef, className: handleClass, onMouseDown: (e) => e.preventDefault() },
                React.createElement(ExpandableToolbar_1.ExpandableToolbar, { pane: {
                        transparent,
                        compact: true,
                    }, compact: true, menu: menu }))));
    };
